/* RESPONSIBLE TEAM: team-channels */
export interface SenderEmailAddressSummaryWireFormat {
  id: number | string;
  name: string;
  email: string;
  status: string;
  verified: boolean;
  custom_bounce_valid: boolean;
  dmarc_valid: boolean;
  sender_email_address_settings_id: number;
  brand_id: number | null;
  brand_name: string | null;
}

export default class SenderEmailAddressSummary {
  readonly id: number | string;
  readonly name: string;
  readonly email: string;
  readonly status: string;
  readonly verified: boolean;
  readonly customBounceValid: boolean;
  readonly dmarcValid: boolean;
  readonly senderEmailAddressSettingsId: number;
  readonly brandId: number | null;
  readonly brandName: string | null;

  constructor(
    id: number | string,
    name: string,
    email: string,
    status: string,
    verified: boolean,
    customBounceValid: boolean,
    dmarcValid: boolean,
    senderEmailAddressSettingsId: number,
    brandId: number | null = null,
    brandName: string | null = null,
  ) {
    this.id = id;
    this.name = name;
    this.email = email;
    this.status = status;
    this.verified = verified;
    this.customBounceValid = customBounceValid;
    this.dmarcValid = dmarcValid;
    this.senderEmailAddressSettingsId = senderEmailAddressSettingsId;
    this.brandId = brandId;
    this.brandName = brandName;
  }

  static deserialize(json: SenderEmailAddressSummaryWireFormat): SenderEmailAddressSummary {
    return new SenderEmailAddressSummary(
      json.id.toString(),
      json.name,
      json.email,
      json.status,
      json.verified,
      json.custom_bounce_valid,
      json.dmarc_valid,
      json.sender_email_address_settings_id,
      json.brand_id,
      json.brand_name,
    );
  }

  static serialize(address: SenderEmailAddressSummary): SenderEmailAddressSummaryWireFormat {
    return {
      id: address.id,
      name: address.name,
      email: address.email,
      status: address.status,
      verified: address.verified,
      custom_bounce_valid: address.customBounceValid,
      dmarc_valid: address.dmarcValid,
      sender_email_address_settings_id: address.senderEmailAddressSettingsId,
      brand_id: address.brandId,
      brand_name: address.brandName,
    };
  }
}
